import ReactGA from 'react-ga';

import { env, IS_DEV_MODE } from '@/config/env';

function init() {
  //  Enable debug mode on the local development environment
  ReactGA.initialize(env.GTM_TOKEN || '', { debug: IS_DEV_MODE });
}

function sendEvent(payload: any) {
  ReactGA.event(payload);
}

function sendPageview(path: any) {
  ReactGA.set({ page: path });
  ReactGA.pageview(path);
}

export default {
  init,
  sendEvent,
  sendPageview,
};
